import Vue from 'vue'
import Router from 'vue-router'
import articulos from './views/articulos.vue'
import previewArticulo from './views/previewArticulos.vue'
import login from './views/login.vue'
import store from './store';
import buckets from './views/buckets.vue'
import comprobantes from './views/comprobantes.vue'
import parametros from './views/parametros.vue'
import publico from './views/publico.vue'

Vue.use(Router)

let router = new Router({
  base: "/",
  routes: [
    {
      path: '/public',
      name: 'publico',
      component: publico,
      props: true
    },{
    path: '/',
    redirect: `${process.env.VUE_APP_I18N_LOCALE}`
  },
  {
    path: '/:lang',
    caseSensitive: false,
    component: {
      render(c) { return c('router-view') }
    },
    children: [{
      path: '/:lang',
      name: 'login',
      component: login,
      alias: '/login'
    }, {
      path: '/:lang/articulos',
      name: 'articulos',
      component: articulos,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/:lang/articulo/:id',
      name: 'previewArticulo',
      component: previewArticulo,
      props: true,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/:lang/buckets',
      name: 'buckets',
      component: buckets,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:lang/comprobantes',
      name: 'comprobantes',
      component: comprobantes,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:lang/parametros',
      name: 'parametros',
      component: parametros,
      props: true,
      meta: {
        requiresAuth: true
      }
    }]
  },]
})
router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem('usuario') && sessionStorage.getItem('clave')) {
    store.commit('setUser', sessionStorage.getItem('usuario'))
    store.commit('setClave', sessionStorage.getItem('clave'))
    store.commit('setEmpId', sessionStorage.getItem('empId'))
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.usuario && store.getters.clave && store.getters.empId) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router;
